import { styled } from '@mui/system'

// Styled component that replaces CSS file
const StyledRichTextEditor = styled('div')(({ theme }) => ({
  '& .rich-text-field.error': {
    border: `1px solid ${theme.palette.error.dark} !important`,
    outline: 'none !important'
  },
  '& .rich-text-field.error:focus-within': {
    border: `2px solid ${theme.palette.error.dark} !important`,
    borderColor: `${theme.palette.error.dark} !important`,
    outline: 'none !important'
  },
  '& .rich-text-field': {
    border: `1px solid ${theme.palette.grey[100]} !important`,
    borderRadius: '4px !important',
    padding: '8px 14px !important',
    backgroundColor: theme.palette.common.white,
    boxSizing: 'border-box !important',
    transition: 'border-color 0.3s ease-in-out !important'
  },
  '& .rich-text-field:not(.error):focus-within': {
    border: `2px solid ${theme.palette.info.dark} !important`,
    borderColor: `${theme.palette.info.dark} !important`,
    outline: 'none !important'
  },
  '& .rich-text-field.disabled': {
    backgroundColor: ` ${theme.palette.action.muiDisabled} !important`,
    cursor: 'auto !important'
  },
  // Tables (Tiptap renders no borders by default)
  '& .ProseMirror table': {
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    width: '100%',
    margin: '8px 0',
    overflow: 'hidden'
  },
  '& .ProseMirror th, & .ProseMirror td': {
    border: `1px solid ${theme.palette.grey[300]}`,
    padding: '6px 8px',
    verticalAlign: 'top',
    boxSizing: 'border-box',
    position: 'relative',
    minWidth: '1em'
  },
  '& .ProseMirror th': {
    backgroundColor: theme.palette.grey[100],
    fontWeight: 'bold',
    textAlign: 'left'
  },
  '& .ProseMirror .selectedCell:after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    backgroundColor: `${theme.palette.info.light}33`,
    pointerEvents: 'none'
  },
  '& .ProseMirror .column-resize-handle': {
    position: 'absolute',
    right: '-2px',
    top: 0,
    bottom: 0,
    width: '4px',
    backgroundColor: theme.palette.info.dark,
    pointerEvents: 'none'
  }
}))

export default StyledRichTextEditor
